import { useState, useEffect, useRef } from 'react';

import Checkbox from '../checkbox/checkbox';

import { useOutsideClick } from '../../helpers/clickOutside';

import { ReactComponent as MenuButtonSVG } from '../../icons/table/menu-button.svg';

const Header = ({ data, onChange, fetching }) => {
  const menuRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [options, setOptions] = useState(data.options);
  const [selectedAll, setSelectedAll] = useState(false);

  const checkSelect = () => {
    if (options?.length === options?.filter((v) => v.selected).length) {
      setSelectedAll(true);
    } else {
      setSelectedAll(false);
    }
  };

  useEffect(() => checkSelect());

  // when done fetching, set the doctor options to sorted by last name
  useEffect(() => {
    if (!fetching && data.label === 'Doctor') setOptions(data.options);
  }, [fetching, data.label, data.options]);

  useOutsideClick(menuRef, () => setShowDropdown(false));

  const onToggleDropdown = () => {
    setShowDropdown(!showDropdown);

    if (options.length === options.filter((v) => v.selected).length) {
      setSelectedAll(true);
    }
  };

  const onCheckboxChange = (option) => {
    const optionIndex = options.findIndex((o) => o.id === option.id);
    options[optionIndex].selected = !options[optionIndex].selected;

    setOptions(options);
    onChange(options);
    checkSelect();
  };

  const onAllSelect = (options) => {
    options.map((option) => (option.selected = !selectedAll));
    setOptions(options);
    setSelectedAll(!selectedAll);

    onChange(options);
  };

  return (
    <div ref={menuRef} className={`th-select-header ${data.classNames}`}>
      {data.isFilterable ? (
        <div
          className="th-select-trigger"
          onClick={onToggleDropdown}
          data-cy={data.label}
        >
          <div className="th-select-header-label">{data.label}</div>
          <MenuButtonSVG />
        </div>
      ) : (
        <div
          data-rh={data.tooltip}
          className="flex items-center justify-between"
        >
          {data.label}
        </div>
      )}
      {showDropdown && (
        <div
          className="th-select-filter-dropdown"
          style={{
            width: '239px',
            top: '42px',
          }}
        >
          <ul
            role="listbox"
            className="th-select-options"
            style={{ maxHeight: '50vh', overflow: 'auto' }}
          >
            <li
              id="select-all"
              role="option"
              className="th-select-option th-select-option-select-all pointer"
              aria-selected={selectedAll}
            >
              <Checkbox
                checked={selectedAll && selectedAll !== 'notAll'}
                label="Select all"
                onChange={() => onAllSelect(options)}
              />
            </li>

            {options.map((option) => (
              <li
                role="option"
                key={option.id}
                id={option.id}
                className="th-select-option pointer"
                aria-selected={option.selected}
              >
                <Checkbox
                  label={option.label}
                  checked={!!option.selected}
                  onChange={() => onCheckboxChange(option)}
                />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Header;
